import type { EffectiveRole } from '@domain/entities';
import type { IAccessRepository } from '@domain/repositories';

export class RevokeRoleUseCase {
  constructor(private readonly accessRepository: IAccessRepository) {}

  async execute(userId: string, roleId: string): Promise<EffectiveRole[]> {
    return this.accessRepository.revoke(userId, roleId);
  }
}
